export default __webpack_public_path__ + "static/media/No-pending-challan.9ea7f8b7.svg";